import React, { Component } from 'react';
import track from 'react-tracking';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import _ from 'lodash';
// import store from 'shared/redux/store';
import {
  websocketConnect,
  clearConversationsStack, submitReply, updateSummary, updateStep, getSavedConversation, createConversation,
  clearConversationHistory,
} from 'shared/redux/actions';


import {
  WEBSOCKET_STATUS_CONNECTED,
  // WEBSOCKET_TIMEOUT_SECONDS,
  WEBSOCKET_STATUS_NOT_CONNECTED,
  WEBSOCKET_STATUS_CLOSED,
  BOT_RESERVED_WORDS,
  CUSTOMER_RESERVED_WORDS,
  END_CONVERSATION_START_AGAIN,
  PATH,
  END_DIALOG,
  END_CONVERSATION_THREAD,
  DIALOG,
  // STATUS,
} from 'shared/constants';

import {
  BotTyping,
  BotResponse,
  CustomerResponse,
} from 'components';
import { connect } from 'react-redux';
import ultilitiesService from 'shared/util/ultilitiesService';
import { layoutWithNavbar } from 'layouts';
import PropTypes from 'prop-types';
import { getRTL } from 'shared/redux/selectors';
import { trackCompleteStep } from './layoutChat.tracking';

let timer;
class LayoutChat extends Component {
  static propTypes = {
    displaySavedConvo: PropTypes.bool,
  };

  static defaultProps = {
    displaySavedConvo: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      processedConvo: props.conversations,
      currentInput: !_.isEmpty(props.conversations) ? props.conversations[props.conversations.length - 1].componentType : null,
      responseDelay: 0,
    };
  }

  async componentDidMount() {
    const {
      websocketStatus,
      location,
      conversations,
      onClearConversationHistory,
      onGetSavedConversation,
      onReplySubmit,
      history,
      // onUpdateStep,
      displaySavedConvo,
      onCreateConversation,
    } = this.props;

    if (websocketStatus === WEBSOCKET_STATUS_NOT_CONNECTED && _.isEmpty(conversations)) {
      const dialog = window.location.pathname.split('/')[1];
      if (dialog === DIALOG.CALL_TO_ACTION) {
        history.push(PATH.GOAL_SUMMARY);
      } else {
        history.push(PATH.JOURNEY_OVERVIEW);
      }
    }
    if (websocketStatus === WEBSOCKET_STATUS_CONNECTED && _.isEmpty(conversations)) {
      if (!displaySavedConvo) {
        onClearConversationHistory().then(() => onReplySubmit('hello'));
      } else if (location.state && location.state.isRedo) {
        // onUpdateStep(STATUS.INCOMPLETE);
        onClearConversationHistory().then(() => onReplySubmit('hello'));
      } else if (location.state && location.state.isResume) {
        onGetSavedConversation()
          .then((stopThread) => {
            if (stopThread !== END_CONVERSATION_THREAD) {
              onReplySubmit('hello');
            }
          });
      } else {
        onCreateConversation().then(() => {
          onReplySubmit('hello');
        });
      }
    }

    this.scrollToBottom();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      websocketStatus,
      onReplySubmit,
      onClearConversationsStack,
      subTitle,
      onFinish,
      onGetSavedConversation,
      displaySavedConvo,
      onClearConversationHistory,
      location,
      history,
      tracking,
      // onUpdateStep,
      onCreateConversation,
    } = this.props;
    const toastOptions = {
      position: 'bottom-center',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    };

    if (snapshot !== null && prevProps.websocketStatus !== snapshot) {
      if (websocketStatus === WEBSOCKET_STATUS_CLOSED) {
        /**
         * Note: There is a bug on iOS, when leaving the app after 35 secs, the socket is closing
         * so we have to force load the page
         */
        onClearConversationsStack();
        toast.error('Your session has closed! Your new session will start in 3 secs.', toastOptions);

        timer = setTimeout(() => {
          // window.location.reload();
          const dialog = window.location.pathname.split('/')[1];
          if (dialog === DIALOG.CALL_TO_ACTION) {
            history.push(PATH.GOAL_SUMMARY);
          } else {
            history.push(PATH.JOURNEY_OVERVIEW);
          }
          // eslint-disable-next-line no-underscore-dangle
        }, 3200);
      }
      if (prevProps.websocketStatus !== websocketStatus && websocketStatus === WEBSOCKET_STATUS_CONNECTED) {
        if (!displaySavedConvo) {
          onClearConversationHistory().then(() => onReplySubmit('hello'));
        } else if (location.state && location.state.isRedo) {
          // onUpdateStep(STATUS.INCOMPLETE);
          onClearConversationHistory().then(() => onReplySubmit('hello'));
        } else if (location.state && location.state.isResume) {
          onGetSavedConversation()
            .then((stopThread) => {
              if (stopThread !== END_CONVERSATION_THREAD) {
                onReplySubmit('hello');
              }
            });
        } else {
          onCreateConversation().then(() => {
            onReplySubmit('hello');
          });
        }
      }
    }
    // simulate auto reply
    if (this.props.conversations[this.props.conversations.length - 1] && this.props.conversations[this.props.conversations.length - 1].simulation) {
      // debugger;
      // store.dispatch(websocketSend('simulation'));
      if (!displaySavedConvo) {
        onClearConversationHistory().then(() => onReplySubmit('hello'));
      } else if (location.state && location.state.isRedo) {
        // onUpdateStep(STATUS.INCOMPLETE);
        onClearConversationHistory().then(() => onReplySubmit('hello'));
      } else if (location.state && location.state.isResume) {
        onGetSavedConversation()
          .then((stopThread) => {
            if (stopThread !== END_CONVERSATION_THREAD) {
              onReplySubmit('hello');
            }
          });
      } else {
        onCreateConversation().then(() => {
          onReplySubmit('hello');
        });
      }
    }
    this.scrollToBottom();

    if (!_.isEmpty(this.props.conversations) && !_.isEqual(this.props.conversations, prevProps.conversations)) {
      const oldConvo = _.intersection(this.props.conversations, prevProps.conversations);
      const newConvo = _.difference(this.props.conversations, prevProps.conversations);

      const convo = [...oldConvo, ...newConvo];
      let lastDelay = 0;
      // get typing delay of message before current message, if customer response then no delay (0)
      if (oldConvo.length) lastDelay = !newConvo[0].customer ? (convo[oldConvo.length - 1].typingDelay || 0) : 0;
      const responseDelay = lastDelay ? this.state.responseDelay + lastDelay : 0;

      // back to overview page on endConversation
      if (newConvo[0].text === END_DIALOG) {
        if (subTitle) {
          const nextStep = _.parseInt(subTitle.split(' ')[1]) + 1;

          if (typeof onFinish === 'function') onFinish();

          if (nextStep <= 3) {
            setTimeout(() => {
              onClearConversationsStack();
              this.props.history.push(PATH.JOURNEY_OVERVIEW);
            }, 3000);
          } else { // complete all steps
            setTimeout(() => {
              onClearConversationsStack();
              this.props.history.push({
                pathname: PATH.INVESTMENT_SUMMARY,
                state: { isFromStep: true },
              });
            }, 3000);
          }
        } else if (typeof onFinish === 'function') {
          setTimeout(() => {
            onClearConversationsStack();
            onFinish();
          }, 3000);
        }
        /** track complete step */
        const step = window.location.pathname.split('/')[1];
        trackCompleteStep(tracking, step);
        /** */
      } else {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          // eslint-disable-next-line react/no-access-state-in-setstate
          responseDelay,
        }, () => {
          setTimeout(() => this.setState({
            processedConvo: convo,
            currentInput: !_.isEmpty(newConvo) ? newConvo[0].componentType : null,
          }), this.state.responseDelay);
        });
      }
    }
  }

  componentWillUnmount() {
    this.props.onClearConversationsStack();
    clearTimeout(timer);
  }

  getSnapshotBeforeUpdate(prevProps) {
    if (prevProps.websocketStatus !== this.props.websocketStatus) {
      return this.props.websocketStatus;
    }
    return null;
  }

    scrollToBottom = () => {
      if (this.messagesEnd) {
        this.messagesEnd.scrollIntoView({ behavior: 'smooth' });
      }
    };

    render() {
      const {
        inputComponent,
        isBotTyping,
        rtl,
        input,
      } = this.props;

      return (
        <section className="app-wrapper__body">
          <div className="container container--conversation">

            {this.state.processedConvo.map((message, index) => {
              // Bot Response
              if (message.type === 'typing') {
                return null;
              }

              if (BOT_RESERVED_WORDS.includes(message.text)) {
                return null;
              }

              switch (message.type) {
                default: // regular bot response
                  if (message.text && !message.customer) {
                    return (
                      <BotResponse
                        rtl={rtl}
                        key={index}
                        message={message.text}
                            // decode html entities _.unescape
                        options={ultilitiesService.isJSON(_.unescape(message.option)) ? JSON.parse(_.unescape(message.option)) : message.option}
                        isFinish={message.componentType === END_CONVERSATION_START_AGAIN}
                        timestamp={message.timestamp}
                        cta={message.cta}
                      />
                    );
                  }
              }

              // Customer Response
              if (message.customer && !CUSTOMER_RESERVED_WORDS.includes(message.text)) {
                return (
                  <CustomerResponse rtl={rtl} key={index} message={message.text} option={message.option} />
                );
              }
              return null;
            })}
            <div
              className="separator"
              ref={(el) => {
                this.messagesEnd = el;
              }}
            />
          </div>
          <BotTyping isTyping={isBotTyping} />

          <div className="container container--footer">
            {this.state.currentInput === inputComponent && input}
          </div>
          <ToastContainer rtl={rtl} />
        </section>
      );
    }
}


const mapStateToProps = state => ({
  inputComponent: state.rootReducer.inputComponent,
  websocketStatus: state.rootReducer.websocketStatus,
  isBotTyping: state.rootReducer.isBotTyping,
  shouldCreateConvo: state.rootReducer.shouldCreateConvo,
  rtl: getRTL(state.rootReducer),
});

const mapDispatchToProps = ({
  onReplySubmit: submitReply,
  onClearConversationsStack: clearConversationsStack,
  onUpdateSummary: updateSummary,
  onUpdateStep: updateStep,
  onGetSavedConversation: getSavedConversation,
  onClearConversationHistory: clearConversationHistory,
  onWebsocketConnect: websocketConnect,
  onCreateConversation: createConversation,
});

export default track({
  page: 'LayoutChat',
})(connect(
  mapStateToProps,
  mapDispatchToProps,
)(layoutWithNavbar(LayoutChat)));
